import Referrals from '@/api/referrals'

export default {
  namespaced: true,
  state: {
    referrers: [{
      firstName: 'will',
      lastName: 'park',
      location: 'Seoul',
      profilePictureUrl: 'https://s3.eu-west-1.amazonaws.com/io.hirevibes.images/images/oPwwr7DivZSDab1eZsmz5JhVDT0Bg0IC-TDLNzdAGrRNBWsf83fam05iQM1pUIeoF.jpeg',
      role: 'Software Engineer',
      companyName: 'Hirevibes'
    }]
  },
  getters: {
  },
  mutations: {
    setReferrals (state, referrals) {
      state.referrals = referrals
    }
  },
  actions: {
    async getReferrals ({ commit }) {
      const referrals = await Referrals.get()
      commit('setReferrals', referrals)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hired-referrals.js